import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 8c0-3.563 2.62-6.51 6.03-7v14C3.62 14.51 1 11.563 1 8ZM9.04 9.01V15c3.082-.443 5.52-2.893 5.96-5.99H9.04ZM15 6.99C14.56 3.893 12.122 1.443 9.04 1v5.99H15Z" />
  </svg>
);
export default IconDrillingPartRightFilledSizeS;
